import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})

export class MenuService {

  private tokenFromStorageSource = new BehaviorSubject<String>("");
  public tokenFromStorage$ = this.tokenFromStorageSource.asObservable();

  constructor(public storage: Storage,private helperService:HelperService) { 
    
  }

  storageToken(value) {
		this.tokenFromStorageSource.next(value.token);
	}


  async decodeToken() {
    const token = await this.storage.get('token');
    let decoded_token
    await this.helperService.decode(token).then((d)=>{decoded_token=d})
    return decoded_token;
  }


}
